<template>
    <Mz-Dialog class="dialog" :title="title" width="3800px" :visible.sync="visible" @handleClose="handleClose">
        <div slot="content" class="main" v-loading="loading" element-loading-text="拼命加载中" element-loading-background="rgba(0,0,0,0)">
            <iframe :src="url" width="100%" height="1500px"></iframe>
        </div>
    </Mz-Dialog>
</template>

<script>
import echarts from 'echarts'
    export default {
        components: {},
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: ''
            },
            url: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                loading: false
            }
        },
        created() {
        },
        mounted() {
        },
        methods: {
            handleClose(){
                this.$emit('update:visible', false)
            }
        }
    }
</script>

<style lang="less" scoped>
@import '@/styles/common';
.main{
    background: #fff;
}
iframe{
    transform: scale(2);
    transform-origin: center top;
}
</style>